<template>
  <div class="ui centered padded grid">
    <div class="six wide computer sixteen wide mobile column">
      <language-toggle/>
      <center>
        <div class="ui inverted huge header">
          {{ localization.loginPage.loginTitle }}
          <div class="sub header">{{ localization.loginPage.loginSubtitle }}</div>
        </div>
      </center>

      <div class="ui top attached inverted segment">
        <!--
        <center>
          <p/>

          <button
            id="signinButtonGoogle"
            class="ui blue button"
            @click="googleSignIn"><i class="google icon"/>{{ localization.loginPage.googleLogin }}</button>

        </center>

        <div class="ui inverted horizontal divider">
          {{ localization.loginPage.or }}
        </div>
        -->

        <div class="ui form">
          <div class="field">
            <label style="color: white;">{{ localization.loginPage.email }}</label>
            <input
              v-model="currentUserEmail"
              type="email"
              placeholder="email@example.com">
          </div>

          <div class="field">
            <label style="color: white;">{{ localization.loginPage.password }}</label>
            <input
              v-model="currentUserPassword"
              type="password">
          </div>

          <div
            v-if="hasError"
            class="ui negative small message">
            {{ errorText }}
          </div>
          <center>
            <div
              class="ui tertiary button"
              @click="emailSignIn"><i class="envelope icon"/> {{ localization.loginPage.emailLogin }}</div>
          </center>
        </div>

      </div>
      <div class="ui bottom inverted tertiary attached message">
        <div class="ui small inverted header">{{ localization.loginPage.downloadInstructionTitle }}</div>
        <p
          style="color: white;"
          v-html="localization.loginPage.downloadInstructionBody">

        </p>

        <!--1. Download Migraine Buddy on <a-->
        <!--style="color: white;"-->
        <!--href=""><b><u>Android</u></b></a> or <a-->
        <!--style="color: white;"-->
        <!--href=""><b><u>iOS</u></b></a>-->
        <!--<br>2. Create an account with your email or Google-->
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import LanguageToggle from '../components/common/LanguageToggle'

export default {
  name: 'LoginPage',
  props: {
    // TODO: Write all the messages for all these different states
    errorStatusCode: {
      type: String,
      required: false,
      default: function () {
        return null
      }
    },
    infoMessage: {
      type: String,
      required: false,
      default: function () {
        return null
      }
    }
  },
  components: {
    LanguageToggle
  },
  data () {
    return {
      currentUserEmail: null,
      currentUserPassword: null,
      hasError: false,
      errorText: null
    }
  },
  validations: {
    currentUserEmail: {
      required,
      email
    },
    currentUserPassword: {
      required
    }
  },
  computed: {
    emailSignInPayload () {
      return {
        'appId': 'migraine-android',  // TODO: To check with Mobile Team when this can revert to square-study

        'email': this.currentUserEmail,
        'password': this.currentUserPassword
      }
    }
  },
  methods: {

    ...mapActions(['updateUserProfile']),
    emailSignIn () {
      this.hasError = false
      if (this.$v.$invalid) {
        this.hasError = true
        if (this.$v.$params.currentUserEmail === null) {
          this.errorText = this.localization.errorMessages.invalidEmail
        } else if (this.$v.$params.currentUserPassword === null) {
          this.errorText = this.localization.errorMessages.emptyPassword
        }
      } else {
        this.$http.post(process.env.API_EMAIL_AUTH, this.emailSignInPayload).then(
          (response) => {
            this.updateUserProfile({
              userId: response.body.result.user.id,
              userAuthToken: response.body.result.authenticationToken
            }).then(() => {
              this.$router.push({ name: 'Home' })
            })
          }, (error) => {
            this.hasError = true
            this.errorText = this.localization.errorMessages.invalidCredentials
            if (error.status !== 401 && error.status !== 404) {
              Rollbar.error(error)
            }
          }
        )
      }
    },
    googleSignInPayload (accessToken) {
      return {
        'appId': 'migraine-android', // TODO: To check with Mobile Team when this can revert to square-study
        'appVersion': 'v26.1.4',
        'appVersionCode': 2614,
        'accessToken': {
          'type': 'GOOGLE',
          'accessToken': accessToken
        }
      }
    },
    mockLogin () {
      this.$cookie.set('userAuthToken', process.env.TEST_USERAUTHTOKEN)
      this.$cookie.set('userId', process.env.TEST_USERID)
      this.$cookie.set('userEmail', 'lap@healint.com')

      let payload = {
        userAuthToken: process.env.TEST_USERAUTHTOKEN,
        userId: process.env.TEST_USERID,
        userEmail: 'lap@healint.com'
      }

      this.updateUserProfile(payload).then(() => {
        this.$router.push({ name: 'Home' })
      })
    },
    googleSignIn() {
      this.$gAuth.getAuthCode()
        .then((authCode) => {
          this.googleSignInCallback(authCode).then((response) => {
            this.$router.push({ name: 'Home' })
          }, (error) => {
            console.log(error)
          })
        }, (error) => {
          console.log(error)
        })
    },
    googleSignInCallback (authResult) {

      return new Promise((resolve, reject) => {
        if (authResult) {
          this.$http.post(process.env.API_SOCIAL_AUTH, this.googleSignInPayload(authResult)).then((response) => {
            // TODO: Set results in store
            resolve(response)
          }, (error) => {
            reject(error)
          })
        } else {
          reject('No code in Google authResult')
        }
      })
    }
  },
  mounted () {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/LoginPage.vue